interface LoaderProps {
  message?: string;
  loading: boolean;
}

export default function Loader({
  message = 'Loading application...',
  loading,
}: LoaderProps) {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-9999">
      <div className="text-center">
        <div className="mb-6">
          <div className="h-12 w-12 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin mx-auto" />
        </div>

        <p className="text-lg font-medium text-gray-700 mb-3">{message}</p>

        <div className="flex justify-center space-x-1">
          <div
            className="h-1.5 w-1.5 bg-gray-500 rounded-full animate-pulse"
            style={{ animationDelay: '0ms' }}
          />
          <div
            className="h-1.5 w-1.5 bg-gray-500 rounded-full animate-pulse"
            style={{ animationDelay: '300ms' }}
          />
          <div
            className="h-1.5 w-1.5 bg-gray-500 rounded-full animate-pulse"
            style={{ animationDelay: '600ms' }}
          />
        </div>
      </div>
    </div>
  );
}
